<!-- RECOVERED BY -->
@if (transaction.recoveredBy?.length > 0) {
  <ap-panel *apSecure='[Permissions.ACCESS_ALL_PAYMENTS]'>
    <ap-panel-content>
      <div class='form-horizontal form-label-left'>
        <div class='row recovers-details-container'>
          <div class='col-sm-12 col-md-12 col-xs-12'>
            <span class='section panel-role-title' [ngClass]="{ 'user-view': userView }">{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.TITLE' | translate }}</span>
            <div class='table-responsive recovers-array'>
              <table mat-table #recoversTable [dataSource]='transaction.recoveredBy' id='datatable' class='table table-hover table-bordered table-fixed no-footer' role='grid' aria-describedby='datatable_info'>
                <!-- RECOVER REFERENCE -->
                <ng-container matColumnDef='{{ recoversColumns[0] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.RECOVER_LIST.COLUMNS.' + recoversColumns[0] | translate }}</th>
                  <td mat-cell *matCellDef='let recover'>{{ recover.reference | noData }}</td>
                </ng-container>
                <!-- RECOVER DATE -->
                <ng-container matColumnDef='{{ recoversColumns[1] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.RECOVER_LIST.COLUMNS.' + recoversColumns[1] | translate }}</th>
                  <td mat-cell *matCellDef='let recover'>{{ recover.creationDate | date: "dd/MM/yyyy 'à' HH':'mm" | noData }}</td>
                </ng-container>
                <!-- RECOVER PAYMENTMEAN -->
                <ng-container matColumnDef='{{ recoversColumns[2] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.RECOVER_LIST.COLUMNS.' + recoversColumns[2] | translate }}</th>
                  <td mat-cell *matCellDef='let recover'>{{ ('STATUS.TRANSACTIONS.PAYMENTMEAN_TYPE.' + recover.paymentMeanType | translate) + (recover.paymentMeanLabel ?  ' ' + recover.paymentMeanLabel : '') }}</td>
                </ng-container>
                <!-- RECOVER TOTAL AMOUNT -->
                <ng-container matColumnDef='{{ recoversColumns[3] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.RECOVER_LIST.COLUMNS.' + recoversColumns[3] | translate }}</th>
                  <td mat-cell *matCellDef='let recover'>{{ recover.amount | apCurrency | noData }}</td>
                </ng-container>
                <!-- RECOVER STATUS -->
                <ng-container matColumnDef='{{ recoversColumns[4] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.RECOVER_LIST.COLUMNS.' + recoversColumns[4] | translate }}</th>
                  <td mat-cell *matCellDef='let recover'>
                    @if (recover.status === PaymentStatus.PENDING) {
                      <status-label type='TRANSACTIONS.STATUS' [status]='recover.status' hasTooltip='true' tooltipContent="{{ 'TRANSACTIONS.LIST.TOOLTIP.STATUS_PENDING' | translate }}"></status-label>
                    } @else {
                      <status-label type='TRANSACTIONS.STATUS' [status]='recover.status'></status-label>
                    }
                  </td>
                </ng-container>
                <!-- ACTIONS -->
                <ng-container matColumnDef='{{ recoversColumns[5] }}'>
                  <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.TRANSACTION_DETAILS.RECOVERS.RECOVER_LIST.COLUMNS.' + recoversColumns[5] | translate }}</th>
                  <td mat-cell *matCellDef='let recover'><button (click)='navigateToTransactionDetails(recover.paymentId, recover.mobilityAccountId)' class='btn btn-xs btn-default'>{{ 'TRANSACTIONS.LIST.BUTTONS.DETAILS' | translate }}</button></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef='recoversColumns'></tr>
                <tr mat-row *matRowDef='let row; columns: recoversColumns;' role='row' class='odd'></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </ap-panel-content>
  </ap-panel>
}
